<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Segment Manager</h4>
          </div>
          <!-- <div class="col-lg-6 col-sm-6 text-right my-auto">
            <a class="add-btn cursor-pointer" @click="$router.push('/add-segment')">Add</a>
          </div> -->
        </div>

        <div class="page-content">
          <div class="card-body py-0 px-0">
            <!-- Search Row -->
            <div class="row align-items-end mb-3">

              <!-- Search Input -->
              <div class="col-lg-4 col-sm-4">
                <label class="label">&nbsp;</label>
                <div class="has-search ml-3">
                  <i class="fa fa-search" style="position: absolute; margin: 10px"></i>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                    @keyup.enter="getList(0)"
                  />
                </div>
              </div>

              <!-- Company Filter -->
              <div class="col-lg-4 col-sm-4">
                <label class="label">Company</label>
                <Multiselect
                  mode="single"
                  track-by="company_name"
                  label="company_name"
                  valueProp="id"
                  placeholder="Select"
                  v-model="searchObj.company_id"
                  :options="companyList"
                  searchable="true"
                  @search-change="searchCompanyName($event)"
                />
              </div>               

              <!-- Buttons (UNCHANGED COLORS) -->
              <div class="col-lg-4 col-sm-4 d-flex">
                <a
                  class="search-btn btn-style cursor-pointer mr-2"
                  @click="getList(0)"
                >
                  Search
                </a>

                <a
                  class="search-btn btn-style cursor-pointer"
                  @click="resetFilter()"
                >
                  Reset
                </a>
              </div>

            </div>

            <!-- Table -->
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th class="sorting" id="name-col" @click="sorting('name','name-col')">Segment Name</th>
                        <!-- <th class="sorting" id="id-status" @click="sorting('status','id-status')">Status</th> -->
                         <th class="sorting" id="company-col" @click="sorting('company_name','company-col')"> Company </th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody v-show="!loader">
                      <tr v-for="(data, index) in list" :key="index">
                        <td>{{ ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage + index + 1 }}</td>
                        <td>{{ data.name }}</td>
                        <!-- <td>
                          <a v-if="data.status === 'ACTIVE'" class="fill-btn btn-style">ACTIVE</a>
                          <a v-else-if="data.status === 'INACTIVE'" class="reject-btn btn-style">INACTIVE</a>
                        </td> -->
                        <td>
                          {{ data.company?.company_name || '—' }}
                        </td>
                        <td>
                          <a class="edit-btn btn-style cursor-pointer" @click="$router.push('/edit-segment/' + data.id)">
                            Edit
                          </a>
                          <a class="delete-btn btn-style cursor-pointer" @click="showDeletePopup(data)">
                            Delete
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-right">
                    <Pagination
                      ref="listPagination"
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                    />
                  </div>
                </div>

                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TextModal ref="segmentDeleteModal">
      <div class="modal-header pt-0">
        <h5 class="modal-title">Delete Segment</h5>
        <button type="button" class="close" @click="closeSegmentDeleteModal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <p>
          Are you sure you want to delete
          <strong>{{ deleteSegmentName }}</strong>
          ?
        </p>

        <p>If this segment is in use, you can replace it with another segment</p>

        <!-- Replacement dropdown -->
        <div class="form-group mt-3">
          <label>Replace with </label>
          <span class="text-danger">*</span>
          <Multiselect
            mode="single"
            track-by="id"
            label="name"
            valueProp="id"
            placeholder="Select replacement segment"
            :options="replaceSegmentList"
            v-model="replaceSegmentId"
            searchable="true"
            v-on:search-change="searchReplaceSegment($event)" />
        </div>
      </div>

      <div class="text-center mt-4">
        <button id="segment-delete-btn" class="fill-btn px-4 mr-2" @click="confirmDeleteSegment">Delete</button>

        <button class="delete-btn px-4" @click="closeSegmentDeleteModal">Cancel</button>
      </div>
    </TextModal>    
  </div>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import TextModal from "@/components/TextModal";
import Multiselect from "@vueform/multiselect";


export default {
  name: "SegmentManager",
  components: { ErrorComponent, Pagination, TextModal, Multiselect },
  data() {
    return {
      loader: true,
      searchObj: {
        keyword: "",
        company_id: "",
      },
      list: [],
      offset: -1,
      sortBy: "",
      orderBy: "ASC",

    // delete + replace state
    deleteSegmentId: null,
    deleteSegmentName: "",
    replaceSegmentId: null,
    replaceSegmentList: [],
    replaceSegmentKeyword: "",

    companyList: [],

    };
  },
  mounted() {
    this.companylist();
    this.getList(0);
  },
  methods: {
    searchCompanyName(e) {
      if (!e) return;
      this.companyKeyword = e;
      this.companylist();
    },
    companylist() {
      const obj = {};
      if (this.companyKeyword) obj.keyword = this.companyKeyword;
      this.$api.getAPI({
        _action: "/company/list",
        _body: obj,
      }).then(res => {
        this.companyList = res;
        this.companyKeyword = "";
      });
    },

    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;

      if (orderBy) this.searchObj.order_by = orderBy;
      if (sortBy) this.searchObj.sort_by = sortBy;

      this.$api
        .getAPI({ _action: "/segments/list", _body: this.searchObj })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;

          if (page === 0 && this.$refs.listPagination) {
            this.$refs.listPagination.setTotalCount(res.count || 0);
          }

          this.$refs.errorComponent.setData(res, "No segments available");
          this.$refs.errorComponent.updateListLoader(false);
        })
        .catch(() => {
          this.loader = false;
            if (this.$refs.errorComponent) {
                this.$refs.errorComponent.updateListLoader(false);
            }
        });
    },
    sorting(sortBy, id) {
      const obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.searchObj.company_id = "";
      this.getList(0);
      this.companylist();
    },
    searchReplaceSegment(e) {
      if (!e) return;

      this.replaceSegmentKeyword = e;
      this.loadReplaceSegmentList(this.deleteSegmentId);
    },    
    loadReplaceSegmentList(segment) {
      this.replaceSegmentList = [];

      this.$api.getAPI({
        _action: `/segments/list_unpaged/${segment.company_id}`,
      }).then(res => {
        this.replaceSegmentList = res.filter(
          seg => seg.id !== segment.id
        );
      });
    },

    confirmDeleteSegment() {
      if (!this.replaceSegmentId) {
        this.$notify({
          type: "error",
          text: "Please select a replacement segment"
        });
        return;
      }

      this.$api.postAPI({
        _action: "/segments/delete/" + this.deleteSegmentId,
        _body: {
          replace_segment_id: this.replaceSegmentId
        },
        _buttonId: "segment-delete-btn",
      }).then(res => {
        this.$notify({ type: "success", text: res.message });
        this.closeSegmentDeleteModal();
        this.getList(0);
      });
    },

  showDeletePopup(data) {
    this.deleteSegmentId = data.id;
    this.deleteSegmentName = data.name;
    this.replaceSegmentId = null;

    this.loadReplaceSegmentList(data);
    this.$refs.segmentDeleteModal.showModal();
  },
    closeSegmentDeleteModal() {
      this.$refs.segmentDeleteModal.closeModal();

      // optional cleanup (recommended)
      this.deleteSegmentId = null;
      this.deleteSegmentName = "";
      this.replaceSegmentId = null;
      this.replaceSegmentList = [];
      this.replaceSegmentKeyword = "";
    },
    deleteRecord(data) {
      this.$refs.deleteItem.deleteRecord("/segments/delete/" + data.id);
    },
  },
};
</script>
